<template lang="pug">
  .color-kit-highlights-cta(v-if="showHighlightsCTA")
    a.highlights-cta.bg-white.color-black(:href="ctaUrl")
      span.highlights-title.semi-bold.xs-f-medium.max-at-tweak For a soft, sun-kissed look...
      .highlights-image.a-box-xs-1x1
        .a-box-content
          img-box(media-id="6025")

      .highlights-info.text-left
        span.upper.xs-f-xsmall.lg-f-small.max-at-tweak Highlights
        span.xs-f-xsmall.max-at-tweak {{ ctaDesc }}
      span.icon-caret-right.color-slate.xs-f-large.max-at-tweak

</template>

<script>
  import vueQuizSvc from '../../../services/vueQuizSvc';

  export default {
    name: "ColorKitHighlightsCTA",

    computed: {
      advisorAnswers() {
        return this.$root.advisorAnswers || {};
      },

      lightWorksRecommendation() {
        return this.$root.lightWorksRecommendation;
      },

      showHighlightsCTA() {
        return this.advisorAnswers.want_level == 'lighter' && (this.advisorAnswers.hair_shade > 3 || (this.advisorAnswers.natural_hair_shade > 3 && !this.advisorAnswers.hair_shade)) && (!this.highlightsQuizComplete || (this.lightWorksRecommendation && this.lightWorksRecommendation.id));
      },

      ctaDesc() {
        if (this.highlightsQuizComplete && this.lightWorksRecommendation && this.lightWorksRecommendation.id) {
          return this.lightWorksRecommendation.description;
        }
        return 'Find your perfect highlight';
      },

      ctaUrl() {
        if (this.lightWorksRecommendation && this.lightWorksRecommendation.id) {
          return '/product/' + this.lightWorksRecommendation.url_key;
        }
        return '/color-advisor?rectype=lw';
      }
    },

    asyncComputed: {
      highlightsQuizComplete() {
        return vueQuizSvc.isQuizComplete({ name: 'highlights_only' }).then(res => res.data.isComplete);
      }
    }
  }
</script>

<style scoped lang="stylus">
  .color-kit-highlights-cta
    padding 0 3%
    padding-top 1.5em
    text-align center
    
    .highlights-cta
      position relative
      padding 1.5em 5%
      width 90%
      display inline-block
      vertical-align top
      border 1px solid color-fog-light
      border-radius 0.5em
      
      &:focus
      &:active
      &:hover
      &:visited
        color color-black
      
    .highlights-title
      display block
      padding-bottom 0.5em
      
    .highlights-image
    .highlights-info
      display inline-block
      vertical-align top
      
    .highlights-image
      width 25%
      
    .highlights-info
      width 65%
      padding-left 1em
      
      span
        display block
      
    .icon-caret-right
      position absolute
      right 0.75em
      top 50%
      margin-top -0.75em
      
      &:before
        margin 0
        
    @media mq-tablet
      .highlights-cta
        width 70%
        
    @media mq-desktop-md-plus      
      .highlights-cta
        width 100%
        padding 1.5em 3%
      
      .highlights-title
        display inline-block
        top 50%
        padding-top 1.25em
      
      .highlights-image
        width 5em
        margin-left 5%
        
      .highlights-info
        width 45%
        padding-left 3%
    
</style>
